import React from 'react'
import {Button, OverlayTrigger, Popover, Tooltip} from 'react-bootstrap'
import {TableSearchComponent} from '../../../../../_metronic/partials/widgets/search-input/TableSearchComponent'

interface TableHeaderProps {
  search?: string
  addButtonText?: string
  showFilter?: boolean
  handleSearchChange?: (searchQuery: string) => void
  handleAddButton?: () => void
  additionalButtons?: Array<{
    icon: string
    tooltip: string
    onClick: () => void
  }>
  filterContent?: React.ReactNode
  theme?: string
}

const TableHeader: React.FC<TableHeaderProps> = ({
  search,
  addButtonText = 'Add New',
  showFilter = true,
  handleSearchChange,
  handleAddButton,
  additionalButtons = [],
  filterContent = (
    <>
      <p>Filter form content goes here.</p>
      <div className='d-flex justify-content-end'>
        <Button variant='secondary' className='me-2'>
          Close
        </Button>
        <Button variant='primary'>Apply Filters</Button>
      </div>
    </>
  ),
  theme = 'primary',
}) => {
  const renderFilterDropdown = (
    <Popover id='popover-filter' style={{maxWidth: '420px', width: '420px'}}>
      <Popover.Header as='h3'>Filters</Popover.Header>
      <Popover.Body>{filterContent}</Popover.Body>
    </Popover>
  )

  return (
    <div
      className='card-header py-7 flex-wrap flex-md-nowrap w-100 justify-content-between align-items-center gap-3 shadow-sm'
      style={{
        position: 'relative',
        paddingLeft: '10px',
      }}
    >
      {search !== undefined && handleSearchChange && (
        <TableSearchComponent searchQuery={search} onSearchChange={handleSearchChange} />
      )}

      <div className='d-flex ms-auto align-items-center'>
        {handleAddButton && (
          <OverlayTrigger placement='bottom' overlay={<Tooltip>{addButtonText}</Tooltip>}>
            <button
              className='btn btn-light border rounded-circle shadow d-flex justify-content-center align-items-center symbol symbol-40px me-3'
              onClick={handleAddButton}
              style={{width: '40px', height: '40px'}}
            >
              <i
                className={`bi bi-plus-lg fs-2 text-${theme} pe-0`}
                style={{transform: 'translateY(-1px)'}}
              ></i>
            </button>
          </OverlayTrigger>
        )}

        {additionalButtons.map((button, index) => (
          <OverlayTrigger
            key={index}
            placement='bottom'
            overlay={<Tooltip>{button.tooltip}</Tooltip>}
          >
            <button
              className='btn btn-light border rounded-circle shadow d-flex justify-content-center align-items-center symbol symbol-40px me-3'
              onClick={button.onClick}
              style={{width: '40px', height: '40px'}}
            >
              <i
                className={`bi ${button.icon} fs-2 text-${theme} pe-0`}
                style={{transform: 'translateY(-1px)'}}
              ></i>
            </button>
          </OverlayTrigger>
        ))}

        {showFilter && (
          <OverlayTrigger
            trigger='click'
            placement='bottom'
            overlay={renderFilterDropdown}
            rootClose
          >
            <button
              className='btn btn-light border rounded-circle shadow d-flex justify-content-center align-items-center symbol symbol-40px'
              style={{width: '40px', height: '40px'}}
            >
              <i
                className={`bi bi-funnel-fill fs-2 text-${theme} pe-0`}
                style={{transform: 'translateY(-1px)'}}
              ></i>
            </button>
          </OverlayTrigger>
        )}
      </div>
      <span
        className={`position-absolute border-${theme}`}
        style={{
          top: '12px',
          left: '0',
          height: '70%',
          width: '4px',
          backgroundColor: `var(--bs-${theme})`, // Ensures the border color matches the theme
        }}
      ></span>
    </div>
  )
}

export default TableHeader
